import SportParksState from '@/types/SportParksState';

const state: SportParksState = {
    sportParks: [],
    selectedSportsPark: null,
    selectedSportField: null,
};

export default state;
